export default "__VITE_ASSET__OqrCfgG4__"